import Vue from 'vue'
import Vuex from 'vuex'
import site from '@/content/site.json';

Vue.use(Vuex)

// Content used to come from Storyblok. It now lives in src/content/site.json;
// these helpers wrap it in the same { name, slug, uuid, content } shape the
// views were written against.

interface Category { slug: string; title: string; subtitle?: string; layout: string; parent?: string }
interface Post { slug: string; title: string; category: string; short_description?: string; body: string; images: string[]; downloads?: string[] }

const toFile = (filename: string) => ({ id: filename, filename });

const categoryStory = (c: Category) => ({
  name: c.title,
  slug: c.slug,
  uuid: c.slug,
  content: { ...c }
});

const postStory = (p: Post) => ({
  name: p.title,
  slug: p.slug,
  uuid: p.slug,
  content: {
    ...p,
    images: p.images.map(toFile),
    downloads: (p.downloads || []).map(toFile)
  }
});

const categories = site.categories as Category[];
const posts = site.posts as Post[];
const pages = site.pages as Record<string, any>;

export interface RootState {
  navItems: any[];
}

export default new Vuex.Store<RootState>({
  state: {
    navItems: site.nav.map((n, i) => ({ id: i, name: n.name, content: { link: { url: n.url } } }))
  },
  actions: {
    async getItem(ctx, path: string){
      const [type, slug] = path.replace(/^\/|\/$/g, '').split('/');
      if (type === 'categories'){
        const c = categories.find(c => c.slug === slug);
        return c ? categoryStory(c) : null;
      }
      if (type === 'posts'){
        const p = posts.find(p => p.slug === slug);
        return p ? postStory(p) : null;
      }
      return null;
    },
    async getSubCategories(ctx, catId: string){
      return categories.filter(c => c.parent === catId).map(categoryStory);
    },
    async getSubItems(ctx, catId: string){
      return posts.filter(p => p.category === catId).map(postStory);
    },
    async getPage(ctx, slug: string) {
      const page = pages[slug];
      return page ? { name: page.title, slug, content: page } : null;
    },
    async getPost(ctx, slug: string) {
      const p = posts.find(p => p.slug === slug);
      return p ? postStory(p) : null;
    }
  }
})
